import { c } from 'ttag';

import type { NodeEntity } from '@proton/drive';
import { getKnowledgeBaseUrl } from '@proton/shared/lib/helpers/url';

import { SignatureIcon } from '../../legacy/components/SignatureIcon';

/**
 * The method provides a label displayed to a user when there is a signature
 * issue regarding the content of a file that requires acknowledgement before
 * opening the preview.
 *
 * It checks the content author from the revision metadata and also the result
 * of the content itself.
 *
 * The label is not returned if the verification is not requested. It is
 * expected in some contexts to not have the possibility to access the public
 * keys, such as on a public page.
 */
export function getContentSignatureIssueLabel(
    verifyMetadataSignatures: boolean,
    node?: NodeEntity,
    hasContentSignatureIssues?: boolean
): string | undefined {
    if (!verifyMetadataSignatures) {
        return undefined;
    }

    if (hasContentSignatureIssues) {
        return c('Error').t`Data integrity check failed`;
    }

    if (!node) {
        return undefined;
    }

    if (!node.activeRevision) {
        return undefined;
    }

    if (node.activeRevision.contentAuthor.ok) {
        return undefined;
    }

    return node.activeRevision.contentAuthor.error.error;
}

export function SignatureStatus({ contentSignatureIssue }: { contentSignatureIssue?: string }) {
    if (!contentSignatureIssue) {
        return undefined;
    }

    return <SignatureIcon haveSignatureIssues={!!contentSignatureIssue} isFile={true} className="ml-2 color-danger" />;
}

export function SignatureInformation({ contentSignatureIssue }: { contentSignatureIssue?: string }) {
    if (!contentSignatureIssue) {
        return undefined;
    }

    return (
        <>
            {contentSignatureIssue}
            &nbsp;
            <a href={getKnowledgeBaseUrl('/drive-signature-management')} target="_blank">
                {c('Action').t`Learn more`}
            </a>
        </>
    );
}
